import React from "react";
import { CardPortfolio } from "../componets/CardPortfolio";
import './Portfolio.css';

import { Fotter } from "../componets/Fotter";

export const Portfolio = () => {
  return (
    <>
   
    <div className="portfolio-container">
      <div className="container-text">
      <h1 className="port">Portfolio</h1>
      <p className="portfolio">
        Welcome to my portfolio, a showcase of my passion for frontend
        development and a journey through the diverse projects I've crafted.
      </p></div>
      <CardPortfolio/>
    </div>
    <Fotter/>
    </>
  );
};
